/* ==========================================================================
 * zodiac-finder.js — 太陽星座・月星座の判定
 *
 * 【天文計算コアの出典】
 *   i-fragrance.com の assets/moon.js（1,238行）から、太陽と月の黄経を出す
 *   部分だけを機械的に切り出したもの。式は1文字も書き換えていない。
 *   切り出し範囲: tSgn / Get_pr1 / Sun_cal1 / Moon_cal1 と Planet_cal の i=0,1 分岐。
 *   落としたもの: 47都道府県の経緯度テーブル、水星〜冥王星の計算、
 *                 恒星時・アセンダント・ハウスカスプ、逆行判定、DOM操作。
 *
 * 【出生地を入力させない理由】
 *   太陽・月の黄経は地心座標で、経緯度に依存しない。元コードでも経緯度は
 *   アセンダントとハウスカスプの算出にしか使われていない。
 *
 * ※ 出典のライセンスは確認中。詳細は F.room/CLAUDE.md を参照。
 * ========================================================================== */

var FroomZodiacAstro = (function () {
  'use strict';

  /* --- ここから moon.js からの移植（無改変） ------------------------------ */

var tSgn=new Array(12);
tSgn[ 0]="aries";
tSgn[ 1]="taurus";
tSgn[ 2]="gemini";
tSgn[ 3]="cancer";
tSgn[ 4]="leo";
tSgn[ 5]="virgo";
tSgn[ 6]="libra";
tSgn[ 7]="scorpius";
tSgn[ 8]="sagittarius";
tSgn[ 9]="capricornus";
tSgn[10]="aquarius";
tSgn[11]="pisces";

var p1 ,p2 ,p3 ,p4 ,p5 ,p6 ,p7 ,p8 ,p9 ,p10,
    p11,p12,p13,p14,p15,p16,p17,p18,p19,p20,
    p21,p22,p23,p24,p25,p26,p27,p28,p29,p30,
    p31,p32,p33, p99, pt; /* planet parameter */
var cl,cb,rv; /* planet position work */

var pcl=new Array(22); /* planet & casp celestial longitude */
var pcb=new Array(10); /* planet celestial latitude */

function Sind(x){return Math.sin((x)*Math.PI/180)}
function Cosd(x){return Math.cos((x)*Math.PI/180)}

/*******************************************
* planet parameter cal sub                 *
*   input  : jd = julian day               *
*   output : p1-p33,p99 = planet parameter *
*            pt = time parameter           *
*******************************************/

function Get_pr1(jd)
{
  var tt;

  tt=jd-2451545;
  pt=tt/36525+1;

  p1 =0.606434+0.03660110129*tt; /* mean longitude of moon */
  p1 =(p1-Math.floor(p1))*2*Math.PI;
  p2 =0.374897+0.03629164709*tt; /* mean anomary of moon */
  p2 =(p2-Math.floor(p2))*2*Math.PI;
  p3 =0.259091+0.03674819520*tt; /* argument of latitude of moon */
  p3 =(p3-Math.floor(p3))*2*Math.PI;
  p4 =0.827362+0.03386319198*tt; /* mean elongation of moon from sun */
  p4 =(p4-Math.floor(p4))*2*Math.PI;
  p5 =0.347343 - 0.00014709391*tt; /* longitude of moon ascending node */
  p5 =(p5-Math.floor(p5))*2*Math.PI;
  p7 =0.779072+0.00273790931*tt; /* mean longitude of sun */
  p7 =(p7-Math.floor(p7))*2*Math.PI;
  p8 =0.993126+0.00273777850*tt; /* mean anomary of sun */
  p8 =(p8-Math.floor(p8))*2*Math.PI;
  p9 =0.700695+0.01136771400*tt; /* mean longitude of mercury */
  p9 =(p9-Math.floor(p9))*2*Math.PI;
  p10=0.485541+0.01136759566*tt; /* mean anomary of mercury */
  p10=(p10-Math.floor(p10))*2*Math.PI;
  p11=0.566441+0.01136762384*tt; /* argument of latitude of sun */
  p11=(p11-Math.floor(p11))*2*Math.PI;
  p12=0.505498+0.00445046867*tt; /* mean longitude of venus */
  p12=(p12-Math.floor(p12))*2*Math.PI;
  p13=0.140023+0.00445036173*tt; /* mean anomary of venus */
  p13=(p13-Math.floor(p13))*2*Math.PI;
  p14=0.292498+0.00445040017*tt; /* argument of latitude of venus */
  p14=(p14-Math.floor(p14))*2*Math.PI;
  p15=0.987353+0.00145575328*tt; /* mean longitude of mars */
  p15=(p15-Math.floor(p15))*2*Math.PI;
  p16=0.053856+0.00145561327*tt; /* mean anomary of mars */
  p16=(p16-Math.floor(p16))*2*Math.PI;
  p17=0.849694+0.00145569465*tt; /* argument of latitude of mars */
  p17=(p17-Math.floor(p17))*2*Math.PI;
  p18=0.089608+0.00023080893*tt; /* mean longitude of jupiter */
  p18=(p18-Math.floor(p18))*2*Math.PI;
  p19=0.056531+0.00023080893*tt; /* mean anomary of jupiter */
  p19=(p19-Math.floor(p19))*2*Math.PI;
  p20=0.814794+0.00023080893*tt; /* argument of latitude of jupiter */
  p20=(p20-Math.floor(p20))*2*Math.PI;
  p21=0.133295+0.00009294371*tt; /* mean longitude of saturn */
  p21=(p21-Math.floor(p21))*2*Math.PI;
  p22=0.882987+0.00009294371*tt; /* mean anomary of saturn */
  p22=(p22-Math.floor(p22))*2*Math.PI;
  p23=0.821218+0.00009294371*tt; /* argument of latitude of saturn */
  p23=(p23-Math.floor(p23))*2*Math.PI;
  p24=0.870169+0.00003269438*tt; /* mean longitude of uranus */
  p24=(p24-Math.floor(p24))*2*Math.PI;
  p25=0.400589+0.00003269438*tt; /* mean anomary of uranus */
  p25=(p25-Math.floor(p25))*2*Math.PI;
  p26=0.664614+0.00003265562*tt; /* argument of latitude of uranus */
  p26=(p26-Math.floor(p26))*2*Math.PI;
  p27=0.846912+0.00001672092*tt; /* mean longitude of neptune */
  p27=(p27-Math.floor(p27))*2*Math.PI;
  p28=0.725368+0.00001672092*tt; /* mean anomary of neptune */
  p28=(p28-Math.floor(p28))*2*Math.PI;
  p29=0.480856+0.00001663715*tt; /* argument of latitude of neptune */
  p29=(p29-Math.floor(p29))*2*Math.PI;
  p31=0.663854+0.00001115482*tt; /* mean longitude of pluto */
  p31=(p31-Math.floor(p31))*2*Math.PI;
  p32=0.041020+0.00001104864*tt; /* mean anomary of pluto */
  p32=(p32-Math.floor(p32))*2*Math.PI;
  p33=0.357355+0.00001104864*tt; /* argument of latitude of pluto */
  p33=(p33-Math.floor(p33))*2*Math.PI;

  p99=(1934*pt-1789)/360;
  p99=(p99-Math.floor(p99))*2*Math.PI;
}

/*************************************
* sun position caliculate sub 1      *
*   (geocentric ecliptic)            *
*  output : cl = longitude [sec,deg] *
*           cb = latitude  [sec,deg] *
*           rv = radius    [AU]      *
*************************************/

function Sun_cal1()
{
  cl =1296000*p7/Math.PI/2;
  cl+=   6910*Math.sin(p8);
  cl+=     72*Math.sin(2*p8);
  cl-=     17*pt*Math.sin(p8);
  cl-=      7*Math.cos(p8-p19);
  cl+=      6*Math.sin(p1-p7);
  cl+=      5*Math.sin(4*p8-8*p16+3*p19);
  cl-=      5*Math.cos(2*p8-2*p13);
  cl-=      4*Math.sin(p8-p13);
  cl+=      4*Math.cos(4*p8-8*p16+3*p19);
  cl+=      3*Math.sin(2*p8-2*p13);
  cl-=      3*Math.sin(p19);
  cl-=      3*Math.sin(2*p8-2*p19);

  cb=0;

  rv =1.00014;
  rv-=0.01675*Math.cos(p8);
  rv-=0.00014*Math.cos(2*p8);
}

/**************************
* moon position cal sub 1 *
*   (geocentric ecliptic) *
**************************/

function Moon_cal1()
{
  cl =1296000*p1/Math.PI/2;
  cl+=  22640*Math.sin(p2);
  cl-=   4586*Math.sin(p2-2*p4);
  cl+=   2370*Math.sin(2*p4);
  cl+=    769*Math.sin(2*p2);
  cl-=    668*Math.sin(p8);
  cl-=    412*Math.sin(2*p3);
  cl-=    212*Math.sin(2*p2-2*p4);
  cl-=    206*Math.sin(p2-2*p4+p8);
  cl+=    192*Math.sin(p2+2*p4);
  cl+=    165*Math.sin(2*p4-p8);
  cl+=    148*Math.sin(p2-p8);
  cl-=    125*Math.sin(p4);
  cl-=    110*Math.sin(p2+p8);
  cl-=     55*Math.sin(2*p3-2*p4);
  cl-=     45*Math.sin(p2+2*p3);
  cl+=     40*Math.sin(p2-2*p3);
  cl-=     38*Math.sin(p2-4*p4);
  cl+=     36*Math.sin(3*p2);
  cl-=     31*Math.sin(2*p2-4*p4);
  cl+=     28*Math.sin(p2-2*p4-p8);
  cl-=     24*Math.sin(2*p4+p8);
  cl+=     19*Math.sin(p2-p4);
  cl+=     18*Math.sin(p4+p8);
  cl+=     15*Math.sin(p2+2*p4-p8);
  cl+=     14*Math.sin(2*p2+2*p4);
  cl+=     14*Math.sin(4*p4);
  cl-=     13*Math.sin(3*p2-2*p4);
  cl-=     11*Math.sin(p2+16*p7-18*p12);
  cl+=     10*Math.sin(2*p2-p8);
  cl+=      9*Math.sin(p2-2*p3-2*p4);
  cl+=      9*Math.cos(p2+16*p7-18*p12);
  cl-=      9*Math.sin(2*p2-2*p4+p8);
  cl-=      8*Math.sin(p2+p4);
  cl+=      8*Math.sin(2*p4-2*p8);
  cl-=      8*Math.sin(2*p2+p8);
  cl-=      7*Math.sin(2*p8);
  cl-=      7*Math.sin(p2-2*p4+2*p8);
  cl+=      7*Math.sin(p5);
  cl-=      6*Math.sin(p2-2*p3+2*p4);
  cl-=      6*Math.sin(2*p3+2*p4);
  cl-=      4*Math.sin(p2-4*p4+p8);
  cl+=      4*pt*Math.cos(p2+16*p7-18*p12);
  cl-=      4*Math.sin(2*p2+2*p3);
  cl+=      4*pt*Math.sin(p2+16*p7-18*p12);
  cl+=      3*Math.sin(p2-3*p4);
  cl-=      3*Math.sin(p2+2*p4+p8);
  cl-=      3*Math.sin(2*p2-4*p4+p8);
  cl+=      3*Math.sin(p2-2*p8);
  cl+=      3*Math.sin(p2-2*p4-2*p8);
  cl-=      2*Math.sin(2*p2-2*p4-p8);
  cl-=      2*Math.sin(2*p3-2*p4+p8);
  cl+=      2*Math.sin(p2+4*p4);
  cl+=      2*Math.sin(4*p2);
  cl+=      2*Math.sin(4*p4-p8);
  cl+=      2*Math.sin(2*p2-p4);

  cb =18461*Math.sin(p3);
  cb+= 1010*Math.sin(p2+p3);
  cb+= 1000*Math.sin(p2-p3);
  cb-=  624*Math.sin(p3-2*p4);
  cb-=  199*Math.sin(p2-p3-2*p4);
  cb-=  167*Math.sin(p2+p3-2*p4);
  cb+=  117*Math.sin(p3+2*p4);
  cb+=   62*Math.sin(2*p2+p3);
  cb+=   33*Math.sin(p2-p3+2*p4);
  cb+=   32*Math.sin(2*p2-p3);
  cb-=   30*Math.sin(p3-2*p4+p8);
  cb-=   16*Math.sin(2*p2+p3-2*p4);
  cb+=   15*Math.sin(p2+p3+2*p4);
  cb+=   12*Math.sin(p3-2*p4-p8);
  cb-=    9*Math.sin(p2-p3-2*p4+p8);
  cb-=    8*Math.sin(p3+p5);
  cb+=    8*Math.sin(p3+2*p4-p8);
  cb-=    7*Math.sin(p2+p3-2*p4+p8);
  cb+=    7*Math.sin(p2+p3-p8);
  cb-=    7*Math.sin(p2+p3-4*p4);
  cb-=    6*Math.sin(p3+p8);
  cb-=    6*Math.sin(3*p3);
  cb+=    6*Math.sin(p2-p3-p8);
  cb-=    5*Math.sin(p3+p4);
  cb-=    5*Math.sin(p2+p3+p8);
  cb-=    5*Math.sin(p2-p3+p8);
  cb+=    5*Math.sin(p3-p8);
  cb+=    5*Math.sin(p3-p4);
  cb+=    4*Math.sin(3*p2+p3);
  cb-=    4*Math.sin(p3-4*p4);
  cb-=    3*Math.sin(p2-p3-4*p4);
  cb+=    3*Math.sin(p2-3*p3);
  cb-=    2*Math.sin(2*p2-p3-4*p4);
  cb-=    2*Math.sin(3*p3-2*p4);
  cb+=    2*Math.sin(2*p2-p3+2*p4);
  cb+=    2*Math.sin(p2-p3+2*p4-p8);
  cb+=    2*Math.sin(2*p2-p3-2*p4);
  cb+=    2*Math.sin(3*p2-p3);
}

  /* --- ここまで移植（無改変） --------------------------------------------- */

  /* Planet_cal(jd) の i==0（太陽）と i==1（月）の分岐だけを抜き出したもの。
     惑星は使わないので i>=2 のブロックごと落としている。
     sl/sr/sx/sy は惑星側でしか使われないが、元の式のまま残してある。 */
  function sunMoonLongitude(jd)
  {
    var gcl,gcb, sl,sr, sx,sy, i;

    Get_pr1(jd); /* planet parameter cal */

    for(i=0; i<2; i++)
      {
        if(i==0) /* sun position cal */
          {
            Sun_cal1();
            gcl=cl/1296000;
            gcl=(gcl-Math.floor(gcl))*Math.PI*2;
            gcb=cb;
            sl=gcl;
            sr=rv;
            sx=rv*Math.cos(gcl);
            sy=rv*Math.sin(gcl);
            gcl-=0.0057*Math.PI/180; /* apparent longitude of sun */
          }

          else /* moon position cal */
          {
            Moon_cal1();
            gcl=cl*Math.PI/648000;
            gcb=cb*Math.PI/648000;
          }

        gcl/=Math.PI*2; /* longitude normalize */
        pcl[i]=(gcl-Math.floor(gcl))*Math.PI*2;
        pcb[i]=gcb;
      }
  }

  /* disp() のユリウス日算出（JST補正込み）をそのまま関数化したもの */
  function jdFromJST(iYear, iMonth, iDay, iHour, iMinute)
  {
    var t, jd;

    if(iMonth<3)
      {
        iYear -=1;
        iMonth+=12;
      }
    t  =Math.floor(iYear/100);
    jd =Math.floor(iYear*365.25)-t+Math.floor(t/4);
    jd+=Math.floor(30.6001*(iMonth+1))+iDay+1720996.5;
    jd+=iHour/24+iMinute/1440;
    jd-=9.0/24.0; /* JST compensate */

    return jd;
  }

  /* 黄経(rad) → 星座。disp() と同じ丸め順序を踏襲する（境界の挙動を一致させるため）:
     分角に floor してから 1800分角(=30度)で割る */
  function toSign(rad)
  {
    var arcmin = Math.floor(rad * 10800 / Math.PI);
    var index  = Math.floor(arcmin / 1800);
    var rest   = arcmin - index * 1800;
    return {
      index: index,
      key:   tSgn[index],
      deg:   Math.floor(rest / 60),
      min:   rest - Math.floor(rest / 60) * 60
    };
  }

  /* ある瞬間の太陽星座・月星座 */
  function signAt(jd)
  {
    sunMoonLongitude(jd);
    return { sun: toSign(pcl[0]), moon: toSign(pcl[1]) };
  }

  var MINUTE = 1 / 1440;

  /* 判定の実力（分）。Astronomy Engine と 1930-2015 の全日で突き合わせた実測値。
     太陽は黄経の系列展開が粗く、切替時刻が中央値5分・最大12分ずれる（100%が15分以内）。
     月は最大2分。UIがこの実力を超えた精度を名乗らないための値。 */
  var UNCERTAINTY = { sun: 15, moon: 2 };

  /* その日のうちに星座が変わるかを判定する。
     変わらなければ certain:true、変わるなら切替時刻(JST・分精度)を返す。
     「生まれた時刻がわからない」人に12:00で当て推量を返さないための中核。 */
  function signSpan(body, y, m, d)
  {
    var slack   = UNCERTAINTY[body];
    var jdStart = jdFromJST(y, m, d, 0, 0);
    var jdEnd   = jdFromJST(y, m, d, 23, 59);
    var first   = signAt(jdStart)[body];
    var last    = signAt(jdEnd)[body];

    if (first.index === last.index) {
      /* 両端が同じでも、境界が誤差の範囲内にかかっていれば言い切らない。
         （1930-2015 で該当は太陽2日。切替が深夜0時のすぐ外側にある日） */
      var before = signAt(jdStart - slack * MINUTE)[body];
      var after  = signAt(jdEnd   + slack * MINUTE)[body];
      return {
        certain: true,
        key: first.key,
        index: first.index,
        nearBoundary: (before.index !== first.index || after.index !== last.index),
        uncertaintyMinutes: slack
      };
    }

    /* 切替の瞬間を二分探索で1分まで詰める */
    var lo = jdStart, hi = jdEnd;
    while (hi - lo > MINUTE / 2) {
      var mid = (lo + hi) / 2;
      if (signAt(mid)[body].index === first.index) { lo = mid; } else { hi = mid; }
    }
    var minutes = Math.round((hi - jdStart) * 1440);
    var hh = Math.floor(minutes / 60);
    var mm = minutes - hh * 60;

    return {
      certain: false,
      from: first.key, fromIndex: first.index,
      to:   last.key,  toIndex:   last.index,
      changesAtJST: (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm,
      changesAtMinutes: minutes,
      uncertaintyMinutes: slack
    };
  }

  function sunSignSpan(y, m, d)  { return signSpan('sun',  y, m, d); }
  function moonSignSpan(y, m, d) { return signSpan('moon', y, m, d); }

  /* 検算用: 太陽・月の黄経を度で返す（分角への丸めをかけない生の値） */
  function longitudesAt(jd)
  {
    sunMoonLongitude(jd);
    return { sun: pcl[0] * 180 / Math.PI, moon: pcl[1] * 180 / Math.PI };
  }

  return Object.freeze({
    signs: tSgn.slice(),
    jdFromJST: jdFromJST,
    signAt: signAt,
    longitudesAt: longitudesAt,
    sunSignSpan: sunSignSpan,
    moonSignSpan: moonSignSpan
  });
})();

/* ==========================================================================
 * <zodiac-finder> — 太陽星座・月星座の診断UI
 *
 * 入力は1つのフォーム。生年月日（必須）＋生まれた時刻（任意）で、
 * ボタン1つで太陽星座と月星座の両方を出す。
 *
 * 表示の原則: 判定の実力（太陽±15分 / 月±2分）を超えた精度を名乗らない。
 * 時刻が空のときに12:00で当て推量を返すことはしない。
 *   → その日に星座が変わるかを調べ、変わるなら切替時刻を出して選ばせる。
 * ========================================================================== */

/* customElements の存在を見てから登録する。
   ブラウザ以外（検算用の Node など）でこのファイルを読み込んでも、
   上の計算コアだけを取り出して使えるようにするため。 */
if (typeof customElements !== 'undefined' && !customElements.get('zodiac-finder')) {
  customElements.define(
    'zodiac-finder',
    class ZodiacFinder extends HTMLElement {
      connectedCallback() {
        if (typeof FroomZodiacAstro === 'undefined') return;

        try {
          this.signs = JSON.parse(this.dataset.signs || '[]');
        } catch (e) {
          return;
        }
        if (this.signs.length !== 12) return;

        this.maxYear = parseInt(this.dataset.maxYear, 10) || new Date().getFullYear();
        this.refPrefix = this.dataset.refPrefix || 'blogzodiac';

        this.yearEl = this.querySelector('[data-year]');
        this.monthEl = this.querySelector('[data-month]');
        this.dayEl = this.querySelector('[data-day]');
        this.hourEl = this.querySelector('[data-hour]');
        this.minuteEl = this.querySelector('[data-minute]');
        this.btn = this.querySelector('[data-submit]');
        this.errorEl = this.querySelector('[data-error]');
        this.sunResult = this.querySelector('[data-sun-result]');
        this.moonResult = this.querySelector('[data-moon-result]');
        this.fallback = this.querySelector('[data-fallback]');
        this.body = this.querySelector('[data-body]');

        if (!this.yearEl || !this.monthEl || !this.dayEl || !this.btn) return;
        if (!this.hourEl || !this.minuteEl) return;

        // JSが動いた時点でフォームを出す（動かなければ静的な案内文だけが残る）
        this.fallback.hidden = true;
        this.body.hidden = false;

        this.monthEl.addEventListener('change', () => this.syncDays());
        this.yearEl.addEventListener('change', () => this.syncDays());
        this.btn.addEventListener('click', () => this.onSubmit());

        this.restoreFromHash();
      }

      /* ---------- 入力まわり ---------- */

      daysInMonth(year, month) {
        if (month === 2) {
          const leap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
          return leap ? 29 : 28;
        }
        return [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1] || 31;
      }

      syncDays() {
        const y = parseInt(this.yearEl.value, 10);
        const m = parseInt(this.monthEl.value, 10);
        if (!m) return;
        const max = this.daysInMonth(y || 2000, m);
        const current = parseInt(this.dayEl.value, 10);
        if (this.dayEl.options.length - 1 === max) return;

        this.dayEl.innerHTML = '';
        const ph = document.createElement('option');
        ph.value = '';
        ph.textContent = '日';
        this.dayEl.appendChild(ph);
        for (let d = 1; d <= max; d++) {
          const opt = document.createElement('option');
          opt.value = String(d);
          opt.textContent = d + '日';
          this.dayEl.appendChild(opt);
        }
        if (current && current <= max) this.dayEl.value = String(current);
      }

      readDate() {
        const y = parseInt(this.yearEl.value, 10);
        const m = parseInt(this.monthEl.value, 10);
        const d = parseInt(this.dayEl.value, 10);
        if (!y || !m || !d) return null;
        if (y < 1900 || y > this.maxYear) return null;
        if (d > this.daysInMonth(y, m)) return null;
        return { y: y, m: m, d: d };
      }

      /* 時刻は任意。時が未選択なら「不明」として扱う（分だけの入力は意味を持たない）。 */
      readTime() {
        const h = parseInt(this.hourEl.value, 10);
        if (isNaN(h)) return null;
        const mi = parseInt(this.minuteEl.value, 10);
        return { h: h, mi: isNaN(mi) ? 0 : mi };
      }

      /* ---------- 本体 ---------- */

      onSubmit() {
        const date = this.readDate();
        if (!date) {
          this.show(this.errorEl);
          this.hide(this.sunResult);
          this.hide(this.moonResult);
          return;
        }
        this.hide(this.errorEl);

        const time = this.readTime();
        const at = time
          ? FroomZodiacAstro.signAt(FroomZodiacAstro.jdFromJST(date.y, date.m, date.d, time.h, time.mi))
          : null;

        this.renderSun(date, time, at);
        this.renderMoon(date, time, at);
        this.updateHash();
      }

      renderSun(date, time, at) {
        const span = FroomZodiacAstro.sunSignSpan(date.y, date.m, date.d);
        let html;

        if (time) {
          // 時刻がわかっているので確定する。変わり目の日だった場合だけ幅を断る。
          this.sunKey = at.sun.key;
          html = this.resultBlock('あなたの太陽星座は', this.signOf(at.sun.key), '生き方・意志・人生で目指す方向性を表す星座です。');
          if (!span.certain) {
            html += this.note(
              'この日は ' + span.changesAtJST + 'ごろに ' + this.signOf(span.from).name +
              ' から ' + this.signOf(span.to).name + ' へ移る、星座の変わり目の日です。' +
              '切替時刻の前後' + span.uncertaintyMinutes + '分に生まれた方は、念のため母子手帳で分単位の時刻をご確認ください。'
            );
          }
        } else if (span.certain) {
          this.sunKey = span.key;
          html = this.resultBlock('あなたの太陽星座は', this.signOf(span.key), '生き方・意志・人生で目指す方向性を表す星座です。');
          if (span.nearBoundary) {
            html += this.note('この日は星座の変わり目のすぐ近くです。生まれた時刻によっては隣の星座になることがあります。');
          }
        } else {
          this.sunKey = null;
          const from = this.signOf(span.from);
          const to = this.signOf(span.to);
          html =
            '<p class="zodiac-finder__cusp-lead">この日は<strong>星座の変わり目</strong>です。</p>' +
            '<p class="zodiac-finder__cusp-body">' +
            span.changesAtJST + 'ごろに <strong>' + from.name + '</strong> から <strong>' + to.name + '</strong> へ移ります。' +
            'それより前に生まれていれば' + from.name + '、後なら' + to.name + 'です。</p>' +
            this.note('切替の時刻は前後' + span.uncertaintyMinutes + '分ほどの幅があります。生まれた時刻を入れると確定できます。');
        }

        this.sunResult.innerHTML = html;
        this.show(this.sunResult);
        if (this.sunKey) {
          this.appendProduct(this.sunResult, this.signOf(this.sunKey).sun, this.refPrefix + '_sun', '昼の香りを見る');
        }
      }

      renderMoon(date, time, at) {
        if (time) {
          this.moonKey = at.moon.key;
          this.moonResult.innerHTML = this.resultBlock(
            'あなたの月星座は',
            this.signOf(at.moon.key),
            '内なる欲求・無意識・安心感を得るところを表す星座です。'
          );
          this.show(this.moonResult);
          this.appendProduct(this.moonResult, this.signOf(at.moon.key).moon, this.refPrefix + '_moon', '夜の香りを見る');
          return;
        }

        // 時刻が空 ── 12:00で当て推量せず、その日に変わるかどうかで答え方を変える
        const span = FroomZodiacAstro.moonSignSpan(date.y, date.m, date.d);

        if (span.certain) {
          this.moonKey = span.key;
          this.moonResult.innerHTML =
            this.resultBlock('あなたの月星座は', this.signOf(span.key), '内なる欲求・無意識・安心感を得るところを表す星座です。') +
            this.note(
              date.y + '年' + date.m + '月' + date.d + '日は、一日を通して' + this.signOf(span.key).name +
              'でした。生まれた時刻がわからなくても確定します。'
            );
          this.show(this.moonResult);
          this.appendProduct(this.moonResult, this.signOf(span.key).moon, this.refPrefix + '_moon', '夜の香りを見る');
          return;
        }

        this.moonKey = null;
        const from = this.signOf(span.from);
        const to = this.signOf(span.to);
        this.moonResult.innerHTML =
          '<p class="zodiac-finder__cusp-lead">この日は月が星座を移った日です。</p>' +
          '<p class="zodiac-finder__cusp-body">' + span.changesAtJST + ' に <strong>' + from.name +
          '</strong> から <strong>' + to.name + '</strong> へ移ります。</p>' +
          '<div class="zodiac-finder__split">' +
          '<div class="zodiac-finder__split-item" data-slot-before><p class="zodiac-finder__split-label">' +
          span.changesAtJST + ' より前に生まれた方</p><p class="zodiac-finder__sign">' + from.name + '</p></div>' +
          '<div class="zodiac-finder__split-item" data-slot-after><p class="zodiac-finder__split-label">' +
          span.changesAtJST + ' 以降に生まれた方</p><p class="zodiac-finder__sign">' + to.name + '</p></div>' +
          '</div>' +
          this.note('母子手帳に出生時刻が書かれていれば、上で時刻を入れると確定できます。');
        this.show(this.moonResult);
        this.appendProduct(this.moonResult.querySelector('[data-slot-before]'), from.moon, this.refPrefix + '_moon', '夜の香りを見る');
        this.appendProduct(this.moonResult.querySelector('[data-slot-after]'), to.moon, this.refPrefix + '_moon', '夜の香りを見る');
      }


      /* ---------- 部品 ---------- */

      signOf(key) {
        return this.signs.find(function (s) { return s.key === key; });
      }

      resultBlock(label, sign, desc) {
        return (
          '<p class="zodiac-finder__result-label">' + label + '</p>' +
          '<p class="zodiac-finder__sign">' + sign.name + '<span class="zodiac-finder__sign-en">' + sign.key + '</span></p>' +
          '<p class="zodiac-finder__sign-desc">' + desc + '</p>'
        );
      }

      note(text) {
        return '<p class="zodiac-finder__note">' + text + '</p>';
      }

      escape(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      /* 商品カード。失敗しても素のリンクは残す（診断結果を行き止まりにしない） */
      appendProduct(container, handle, ref, cta) {
        if (!container || !handle) return;
        const url = '/products/' + handle + '?ref=' + ref;
        const wrap = document.createElement('div');
        wrap.className = 'zodiac-finder__product';
        wrap.innerHTML = '<a class="zodiac-finder__product-link" href="' + url + '">' + cta + '</a>';
        container.appendChild(wrap);

        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('not ok');
            return r.json();
          })
          .then(
            function (p) {
              const img = p.featured_image
                ? '<img class="zodiac-finder__product-image" src="' + p.featured_image + '&width=300" alt="" loading="lazy" width="150" height="150">'
                : '';
              const price = typeof p.price === 'number' ? '¥' + Math.round(p.price / 100).toLocaleString('ja-JP') : '';
              wrap.innerHTML =
                '<a class="zodiac-finder__product-card" href="' + url + '">' +
                img +
                '<span class="zodiac-finder__product-info">' +
                '<span class="zodiac-finder__product-title">' + this.escape(p.title) + '</span>' +
                (price ? '<span class="zodiac-finder__product-price">' + price + '</span>' : '') +
                '<span class="zodiac-finder__product-cta">' + cta + '</span>' +
                '</span></a>';
            }.bind(this),
            function () {
              /* 取得に失敗しても最初のテキストリンクをそのまま残す */
            }
          );
      }

      show(el) { if (el) el.hidden = false; }
      hide(el) { if (el) el.hidden = true; }

      /* ---------- URL ----------
         結果は hash にだけ書く。パスやクエリは触らない（canonical を汚さないため）。 */

      updateHash() {
        const parts = [];
        if (this.sunKey) parts.push('sun=' + this.sunKey);
        if (this.moonKey) parts.push('moon=' + this.moonKey);
        const hash = parts.length ? '#' + parts.join('&') : '';
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search + hash);
        }
      }

      restoreFromHash() {
        const h = window.location.hash.replace(/^#/, '');
        if (!h) return;
        const params = {};
        h.split('&').forEach(function (kv) {
          const p = kv.split('=');
          if (p.length === 2) params[p[0]] = p[1];
        });
        const sun = params.sun && this.signOf(params.sun);
        const moon = params.moon && this.signOf(params.moon);
        if (!sun && !moon) return;

        if (sun) {
          this.sunKey = sun.key;
          this.sunResult.innerHTML = this.resultBlock('あなたの太陽星座は', sun, '生き方・意志・人生で目指す方向性を表す星座です。');
          this.show(this.sunResult);
          this.appendProduct(this.sunResult, sun.sun, this.refPrefix + '_sun', '昼の香りを見る');
        }
        if (moon) {
          this.moonKey = moon.key;
          this.moonResult.innerHTML = this.resultBlock('あなたの月星座は', moon, '内なる欲求・無意識・安心感を得るところを表す星座です。');
          this.show(this.moonResult);
          this.appendProduct(this.moonResult, moon.moon, this.refPrefix + '_moon', '夜の香りを見る');
        }
      }
    }
  );
}
